<template>
  <!-- :class="{ 'no-events': !item.session_state.session_finished }" -->
  <div
    class="trahsessisit"
    :class="{
      trahsessisit_incomplete: item.incomplete,
    }"
    :style="`--clr-score: ${item.stats_session.gto_score_group.clr}`"
    @click="$emit('click')"
  >
    <div class="trahsessisit_content">
      <div class="trahsessisit_score">
        {{ numFixed(item.stats_session.avg_gto_score * 100 || 0) }}%
      </div>
      <div class="pr-2">
        {{ $tc('common.num_hands_session', item.session_state.session_finished_hands_uids.length) }}
      </div>
      <div class="trahsessisit_opener weight_700 gw_btn text-small text-noselect">
        {{ $t('btn.open') }}
      </div>
    </div>
    <div
      v-if="item.incomplete"
      class="trahsessisit_incomplete_text"
    >
      <router-link
        class="gw_btn gw_btn-v1 text-small w-100"
        :to="{
          name: 'PracticeHands',
          query: {
            ffph_session: item.uid,
            ffph_session_name: $t('common.trainer_session'),
          },
        }"
        style="--radius: 0px; --height: 2rem; justify-content: flex-end; padding: 0 0.5rem"
      >
        <div class="mdi text-normal-large mdi-cards-playing-spade-outline mr-1"></div>
        {{ $t('common.see_all_hands') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'

export default {
  name: 'TrainerHistorySessionItem',
  mixins: [format_mix],
  props: {
    item: Object,
  },
  emits: ['click'],
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.trahsessisit {
  position: relative;
  --clr-score: transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  // border-top: 2px solid var(--clr-black-3);
  transition: 0.3s;
  &_content {
    width: 100%;
    height: 3rem;
    font-weight: 500;
    color: var(--clr-white-0);
    padding: 0 0.75rem;
    text-transform: uppercase;
    font-weight: 600;
    display: flex;
    align-items: center;
    white-space: nowrap;
    grid-gap: 0.75rem;
    width: 100%;
    &:hover {
      // background: var(--clr-black-1-3);
      // cursor: pointer;
      // .trahsessisit_opener {
      //   opacity: 1;
      //   transition: 0.2s;
      // }
    }
  }
  &_incomplete {
    // height: 4rem;
    &_text {
      width: 100%;
      font-size: 1rem;
      font-weight: 400;
      text-transform: none;
      bottom: 0rem;
      left: 0;
      display: flex;
      align-self: center;
      justify-content: center;
    }
  }
  &_icon {
    margin: 0 0.75rem 0 0;
  }
  &_score {
    color: var(--clr-score);
  }
  &_opener {
    position: absolute;
    right: 0.5rem;
    // opacity: 0;
    color: var(--clr-grey-2);
  }
}
</style>
